import { ILeaseCustomer, IEvent } from '@/types/admin/events';

export type AttendanceFlags = { checkedIn: boolean; hasRsvp: boolean };

// Resolve attendance flags for a resident against a specific eventId.
export const resolveEventAttendanceFlags = (
  resident: ILeaseCustomer,
  eventId: number,
): AttendanceFlags => {
  const er: any = (resident as any).EventResident;
  const erChecked = typeof er?.checkedIn === 'boolean' ? er.checkedIn : undefined;
  const erRsvp = typeof er?.hasRsvp === 'boolean' ? er.hasRsvp : undefined;

  const events = (resident as any).events;
  const ev = events && Array.isArray(events)
    ? events.find((e: any) => (e as any).id === eventId)
    : undefined;

  const listChecked = !!ev?.rsvpList?.checkedIn;
  const listRsvp = !!ev?.rsvpList?.hasRsvp;

  return {
    checkedIn: erChecked !== undefined ? erChecked : listChecked,
    hasRsvp: erRsvp !== undefined ? erRsvp : listRsvp,
  };
};

export const computeAttendanceStats = (
  attendees: ILeaseCustomer[],
  eventId: number,
) => {
  let checkedIn = 0;
  let rsvps = 0;
  for (const resident of attendees) {
    const flags = resolveEventAttendanceFlags(resident, eventId);
    if (flags.checkedIn) checkedIn += 1;
    if (flags.hasRsvp) rsvps += 1;
  }
  return { checkedIn, rsvps, total: attendees.length };
};

export const generateAttendanceCsv = (
  attendees: ILeaseCustomer[],
  eventId: number,
) => {
  const CSV_COLUMNS = [
    'Name',
    'Email',
    'Customer Type',
    'Unit Number',
    'Status',
    'Checked In',
    "Has RSVP'd",
  ] as const;

  const rows = [
    CSV_COLUMNS as unknown as (string | number | boolean | null)[],
    ...attendees.map((resident) => {
      const name = `${resident.firstName} ${resident.lastName}`.trim();
      const email = resident.email || '';
      const customerType = resident.customerType || '';
      const unit = resident.unitNumberSpace || '';
      const status = resident.statusType || '';
      const flags = resolveEventAttendanceFlags(resident, eventId);
      return [name, email, customerType, unit, status, flags.checkedIn, flags.hasRsvp];
    }),
  ];

  return rows as any;
};


